import Vue from 'vue';
import './reg_composition';
import Root from './Root.vue';
import router from './router';
import store from './stores';
import vuetify from './plugins/vuetify';
import VueClipboard from 'vue-clipboard2';
import VueFinalModal from 'vue-final-modal/lib';
import PortalVue from 'portal-vue';
import './components';
import { i18n, loadLanguageAsync } from './i18n-setup';
import { SET_FOOTER, SET_PAGE } from './stores/modules/app/constants';
import { provide } from 'vue-demi';

import { DefaultApolloClient } from '@vue/apollo-composable';

import apiClient from '@/api/apollo-client';

import VueMeta from 'vue-meta';

Vue.config.productionTip = false;

Vue.use(VueFinalModal());

Vue.use(VueClipboard);

Vue.use(PortalVue);

Vue.use(VueMeta);

Vue.prototype.$showFooter = payload => {
  store.commit(`app/${SET_PAGE}`, payload);
  store.commit(`app/${SET_FOOTER}`, true);
};

Vue.prototype.$closeFooter = () => {
  store.commit(`app/${SET_PAGE}`, '');
  store.commit(`app/${SET_FOOTER}`, false);
};

const worker = new Worker('/worker.js');

// router.beforeResolve(async (to, from, next) => {
//   // const lang = to.params.lang
//   await loadLanguageAsync();
//   next();
// });

new Vue({
  i18n,
  router,
  store,
  vuetify,
  setup(props, context) {
    provide(DefaultApolloClient, apiClient);
    provide('worker', worker);
  },
  render: h => h(Root)
}).$mount('#app');
